const fields = {
  poll: [
    'message',
    'image_path',
    'poll_quiz_question',
    'poll_quiz_option_1',
    'poll_quiz_option_2',
    'poll_quiz_option_3',
    'poll_quiz_option_4',
    'poll_quiz_option_5',
    'poll_quiz_option_6',
    'poll_quiz_option_7',
  ],
  quiz: [
    'image_path',
    'poll_quiz_question',
    'poll_quiz_option_1',
    'poll_quiz_option_2',
    'poll_quiz_option_3',
    'poll_quiz_option_4',
    'poll_quiz_option_5',
    'poll_quiz_option_6',
    'poll_quiz_option_7',
    'correct_answer_feedback',
    'wrong_answer_feedback',
    'quiz_correct_answer'
  ]
};

/**
 * Transform the activities data.
 *
 * @author: Hesan
 * @param {array} acts Array of raw activity objects
 * @returns {array} New array of screen friendly activities
 */
export const screenFriendlyActivities = (acts) => acts.map((activity) => detectType(activity));

/**
 * A function to detect type of activity and only include the matching properties
 * @private
 * @author: Hesan
 * @param {object} activity Raw activity data
 * @returns {object} Reduced activity data with only needes properties.
 */
const detectType = ({
  type,
  campaign_id: campaignId,
  coachable_id: coachableId,
  ...other
}) => {
  const coachable = {
    type,
    campaignId,
    coachableId,
    done: false
  };
  try {
    if (type !== 'feedback') {
      // eslint-disable-next-line no-restricted-syntax
      for (const prop of fields[type]) {
        coachable[prop] = other[prop];
      }
    }
  } catch (e) {
    console.error('There was an error finding the correct type \n', e);
  }
  return coachable;
};

const wwtkReducer = (rawData) => ({
  activities: screenFriendlyActivities(rawData)
});

/**
 * This function is used to compare arrays equality
 *
 * We use this function for comparing done activities and list of activities we're
 * getting from the server
 *
 * @param {array} a first array
 * @param {array} b second array
 * @returns {boolean}
 */
const isArraysEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  const firstArray = [...a].sort();
  const secondArray = [...b].sort();

  for (let i = 0; i < firstArray.length; i += 1) {
    if (firstArray[i] !== secondArray[i]) return false;
  }
  return true;
};

/**
 * Check 6 different Edge Cases for Recycle RIGHT game
 * If one of the edge cases were detetced in the data,
 * the Recycle RIGHT game will not appear in Discovery Zone page
 */

const checkEdgeCaseRecycleRIGHT = (recycleRightData) => {
  let hasNullMaterial = false;
  let redundantMatId = false;
  let hasNotRequiredKey = false;
  let notStandardlevelKey = false;

  /**
   * Edge Case 1:
   * If recycleRIGHT does not exist in Discovery Zone data
   */
  if (!recycleRightData) return false;

  /**
   * Edge Case 2:
   * If recycleRIGHT is empty
   */
  if (Object.keys(recycleRightData).length === 0) return false;

  /**
   * Edge Case 3:
   * If a level key name is not standard
   */
  Object.keys(recycleRightData).forEach((level, index) => {
    if (level !== `level_${index + 1}_materials`) {
      notStandardlevelKey = true;
    }
  });
  if (notStandardlevelKey) return false;

  /**
   * Edge Case 4:
   * If a level does not have any material
   */
  Object.keys(recycleRightData).forEach((level) => {
    if (recycleRightData[level].length === 0) hasNullMaterial = true;
  });
  if (hasNullMaterial) return false;

  /**
   * Edge Case 5:
   * If a mat_id was redundant in recycleRIGHT
   */
  const all_mat_id = [];
  Object.keys(recycleRightData).forEach((key) => {
    recycleRightData[key].forEach((element) => {
      if (all_mat_id.indexOf(element.mat_id) !== -1) {
        redundantMatId = true;
      } else {
        all_mat_id.push(element.mat_id);
      }
    });
  });
  if (redundantMatId) return false;

  /**
   * Edge Case 6:
   * If a material does not have all the required keys or one of the keys value is null
   */
  const materialKeys = ['disposal_body', 'disposal_header', 'is_recyclable', 'mat_id', 'mat_image', 'mat_nm', 'oidx'];
  Object.keys(recycleRightData).forEach((key) => {
    recycleRightData[key].forEach((material) => {
      materialKeys.forEach((requiredKey) => {
        if (!(requiredKey in material) || material[requiredKey] === null) {
          hasNotRequiredKey = true;
        }
      });
    });
  });
  if (hasNotRequiredKey) return false;

  return true;
};

export {
  wwtkReducer as default,
  wwtkReducer,
  isArraysEqual,
  checkEdgeCaseRecycleRIGHT
};
